export default __webpack_public_path__ + "static/Scroll-Image---Shed-Demolition-124e79a9b1043ff3fd5015ba5a051ace.jpg";